define([
    "models/system/field"
], function (Field) {

    function AbstractTableModel(name, fields, url, rules, level) {
        this._modelName = name;
        this.fields = [];
        this._prepareFields(fields);
        this.canSelect = true;
        this.canInsert = true;
        this.canUpdate = true;
        this.canDelete = true;
        this.url = url;
        this._idField = null;
        this.deleteLevel = (level ? level : 6);
        this.updateLevel = (level ? level : 6);
        this.insertLevel = (level ? level : 6);
        this.rules = (rules ? rules : null);
    }

    /**
     * Добавляем дефолтные поля из модели field в поля, которые получили от пользователя, и находим ключевое поле
     * @param fields - список полей в модели
     * @private
     */
    AbstractTableModel.prototype._prepareFields = function (fields) {
        var This = this;
        fields.forEach(function (field) {
            var curField = new Field();
            for (var key in field) {
                if (typeof field[key] !== 'undefined' || field[key] === 0/* || key === "fillspace"*/)
                    curField[key] = field[key];
            }
            if (field.keyField)
                This._idField = field.name;
            This.fields.push(curField);
        });
    };
    /**
     * Возвращает значение ключевого поля
     * @returns {null|*}
     */
    AbstractTableModel.prototype.getIdField = function () {
        return this._idField;
    };

    /**
     * Возвращает строку со значением
     * @returns {{}}
     */
    AbstractTableModel.prototype.getEmptyRecord = function () {
        //var This = this;
        var row = {};
        this.fields.forEach(function (field) {
            row[field.name] = field.defautValue;
        });
        return row;
    };
    return AbstractTableModel;
});